import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const useLanguageFromUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { i18n } = useTranslation();
  const initializedHandlerRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    const pathLanguage = window.location.pathname.startsWith('/fr') ? 'fr' : null;
    const currentLang = i18n.language?.split('-')[0];
    if (pathLanguage && currentLang !== pathLanguage) {
      i18n.changeLanguage(pathLanguage).catch((err) => {
        console.error('Error changing language from path:', err);
      });
    }

    const lngParam = searchParams.get('lng');
    if (lngParam) {
      const currentLang = i18n.language?.split('-')[0];
      const targetLang = lngParam.split('-')[0];
      if (currentLang !== targetLang) {
        const changeLanguageWhenReady = () => {
          i18n.changeLanguage(lngParam).catch((err) => {
            console.error('Error changing language:', err);
          });
        };

        if (i18n.isInitialized) {
          changeLanguageWhenReady();
        } else {
          if (initializedHandlerRef.current) {
            i18n.off('initialized', initializedHandlerRef.current);
          }
          initializedHandlerRef.current = changeLanguageWhenReady;
          i18n.on('initialized', initializedHandlerRef.current);
        }
      }
    }

    return () => {
      if (initializedHandlerRef.current) {
        i18n.off('initialized', initializedHandlerRef.current);
        initializedHandlerRef.current = null;
      }
    };
  }, [searchParams, i18n]);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setSearchParams({ lng });
  };

  return { currentLanguage: i18n.language, changeLanguage };
};

